import React, { Component, Fragment } from "react";
import {
  getSingleOrderApiRedux,
  getSingleProductRequestRedux,
} from "../../actions/index";
import { connect } from "react-redux";
import "./invoice-by-order.css";
import ZapaiLogo from "../../assets/images/zapai-logo.png";
import { withRouter } from "react-router-dom";
import { getSingleUser } from "../../firebase/firebase.utils";

// Renders a numeric amount with its unit suffix, or "-" when the value
// is missing/not a number (instead of an empty "Tk"/"Kg" or "NaN Tk").
const fmtAmt = (value, suffix = "") => {
  const n = parseFloat(value);
  return Number.isFinite(n) ? `${Math.trunc(n)}${suffix}` : "-";
};

export class OnlyInvoieToPrint extends Component {
  state = {
    user: null,
    orderObj: null,
    productRequestObj: null,
    productRequest: null,
  };
  componentDidMount = async () => {
    const query = new URLSearchParams(this.props.location.search);
    const productRequest = query.get("productRequest");
    if (productRequest) {
      await this.props.getSingleProductRequestRedux(
        this.props.match.params.bookingId
      );
    } else {
      await this.props.getSingleOrderApiRedux(
        this.props.match.params.bookingId
      );
    }
    this.setState({
      productRequest,
    });
  };

  componentWillReceiveProps = async (nextProps) => {
    if (nextProps.orderObj && nextProps.orderObj.userId) {
      const user = await getSingleUser(nextProps.orderObj.userId);
      this.setState({
        user: user,
      });
    }
    if (nextProps.productRequestObj && nextProps.productRequestObj.userId) {
      const user = await getSingleUser(nextProps.productRequestObj.userId);
      this.setState({
        user: user,
      });
    }
  };

  componentWillUnmount = () => {};

  render() {
    const { orderObj, productRequestObj } = this.props;
    const { user } = this.state;

    let renderableOrder = null;
    if (this.state.productRequest) {
      renderableOrder = productRequestObj;
    } else {
      renderableOrder = orderObj;
    }

    // Bill-to address: prefer the address captured on the order itself
    // (delivery/shipping address at order time) over the customer's
    // current profile address book, which may have since changed.
    let addressBook = null;
    if (renderableOrder && renderableOrder.deliveryAddress) {
      const da = renderableOrder.deliveryAddress;
      addressBook = {
        name: da.name || da.fullName || "",
        address: da.address || "",
        district: da.district || "",
        division: da.division || "",
        thana: da.thana || "",
        mobileNo: da.mobileNo || "",
      };
    } else if (user && user.addressBook && user.addressBook.length > 0) {
      addressBook = user.addressBook.find((address) => address.defaultShipping);
    }

    // The "ordersApi" collection holds two overlapping field layouts —
    // older admin-created orders (subTotal/discountApplied/couponApplied)
    // and newer checkout-created pre-orders (actualTotal/couponAmount) —
    // so every base-order figure below is normalized across both rather
    // than assuming one shape (same approach as the storefront's own
    // PreOrderInvoice, which reads the same collection).
    const subtotal =
      (renderableOrder && (renderableOrder.actualTotal ?? renderableOrder.subTotal)) || 0;
    const deliveryCharge = (renderableOrder && renderableOrder.deliveryCharge) || 0;
    const discountApplied = (renderableOrder && renderableOrder.discountApplied) || 0;
    const couponDiscount =
      (renderableOrder &&
        (renderableOrder.couponAmount ?? renderableOrder.couponApplied?.discount)) ||
      0;
    const baseTotal = subtotal + deliveryCharge - discountApplied - couponDiscount;

    // Freight/customs charges only exist once an order has been processed
    // through the China-warehouse buy-and-ship-for-me pipeline — absent
    // entirely on a plain pre-order, so each defaults to 0 rather than NaN.
    const otherCost = parseInt(renderableOrder && renderableOrder.otherCost) || 0;
    const shippingChargeCustomer =
      parseInt(renderableOrder && renderableOrder.shippingChargeCustomer) || 0;
    // localShipping ("China Shipping (local)" / post fee) is a checkout-time
    // field every pre-order has, not a signal that this order went through
    // freight processing — informational only, excluded from hasFreightInfo
    // and from the payable total (matches the admin Payment Management
    // modal's Price Breakdown, which shows it the same way).
    const localShipping = parseInt(renderableOrder && renderableOrder.localShipping) || 0;
    const hasFreightInfo = !!(
      renderableOrder &&
      (renderableOrder.receivedWeight ||
        renderableOrder.customerRate ||
        shippingChargeCustomer ||
        otherCost)
    );
    const totalPayableAmountIncludingShipping =
      baseTotal + otherCost + shippingChargeCustomer;

    let totalPaid = 0;
    if (renderableOrder && renderableOrder.payments && renderableOrder.payments.length > 0) {
      renderableOrder.payments.forEach((payment) => {
        totalPaid += parseInt(payment.amount) || 0;
      });
    }
    const due = Math.max(0, totalPayableAmountIncludingShipping - totalPaid);

    const payLabel =
      totalPaid >= totalPayableAmountIncludingShipping && totalPayableAmountIncludingShipping > 0
        ? "Paid"
        : totalPaid > 0
          ? "Partially Paid"
          : "Payment Due";
    const payClass =
      totalPaid >= totalPayableAmountIncludingShipping && totalPayableAmountIncludingShipping > 0
        ? "zp-inv-status--paid"
        : totalPaid > 0
          ? "zp-inv-status--partial"
          : "zp-inv-status--due";

    return (
      <div className="zp-inv-page">
        <div className="zp-inv-card">
          <div className="zp-inv-accent" />

          {payLabel === "Paid" && (
            <div className="zp-inv-paid-stamp">Paid</div>
          )}

          <header className="zp-inv-header">
            <div>
              <div className="zp-inv-brand">
                <img src={ZapaiLogo} alt="Zapai" />
              </div>
              <div className="zp-inv-company-info">
                <div>44/45, 5th floor, Bikrampur Housing</div>
                <div>New Alibohar, Postogola, Dhaka-1204</div>
                <div>+8801560002099 &nbsp;•&nbsp; invoice@zapai.com.bd</div>
              </div>
            </div>
            <div className="zp-inv-title-block">
              <div className="zp-inv-title">Invoice</div>
              <div className="zp-inv-number">
                #PC-{this.props.match.params.bookingId}
              </div>
              <div>
                <span className={`zp-inv-status ${payClass}`}>{payLabel}</span>
              </div>
            </div>
          </header>

          <div className="zp-inv-meta">
            <div>
              <div className="zp-inv-meta-label">Deliver To</div>
              <div className="zp-inv-bill-name">
                {(addressBook && addressBook.name) ||
                  (user && user.displayName) ||
                  "-"}
              </div>
              <div className="zp-inv-bill-line">
                {(addressBook && addressBook.mobileNo) || "-"}
              </div>
              <div className="zp-inv-bill-line">
                {(addressBook && addressBook.address) || "-"}
              </div>
              <div className="zp-inv-bill-line">
                {addressBook && addressBook.district ? `${addressBook.district}, ` : ""}
                {(addressBook && addressBook.division) || ""}
              </div>
            </div>
            <div>
              <div className="zp-inv-meta-label">Invoice Details</div>
              <div className="zp-inv-detail-row">
                <span className="k">Submitted on</span>
                <span className="v">
                  {this.state.productRequest
                    ? productRequestObj && productRequestObj.date
                    : orderObj && orderObj.orderedDate}
                </span>
              </div>
              <div className="zp-inv-detail-row">
                <span className="k">Invoice no</span>
                <span className="v">
                  #PC-{this.props.match.params.bookingId}
                </span>
              </div>
              <div className="zp-inv-detail-row">
                <span className="k">Order ID</span>
                <span className="v">{this.props.match.params.bookingId}</span>
              </div>
              {renderableOrder && renderableOrder.shippingMark && (
                <div className="zp-inv-detail-row">
                  <span className="k">Shipping Mark</span>
                  <span className="v">{renderableOrder.shippingMark}</span>
                </div>
              )}
              {renderableOrder && renderableOrder.ctnNo && (
                <div className="zp-inv-detail-row">
                  <span className="k">Carton No</span>
                  <span className="v">
                    {renderableOrder.ctnNo.toString().replace("CB", "AR")}
                  </span>
                </div>
              )}
              {renderableOrder && renderableOrder.trackingNo && (
                <div className="zp-inv-detail-row">
                  <span className="k">Tracking no</span>
                  <span className="v">{renderableOrder.trackingNo}</span>
                </div>
              )}
            </div>
          </div>

          <div className="zp-inv-section">
            {this.state.productRequest ? (
              productRequestObj && (
                <div className="zp-inv-item-row">
                  <div className="zp-inv-item-info">
                    <div className="zp-inv-item-name">
                      {productRequestObj.store} - {productRequestObj.productType}
                    </div>
                    <div className="zp-inv-item-unit">
                      ৳{fmtAmt(productRequestObj.unitPrice)} ×{" "}
                      {fmtAmt(productRequestObj.productQuantity)}
                    </div>
                  </div>
                  <div className="zp-inv-item-total">
                    {fmtAmt(
                      parseFloat(productRequestObj.unitPrice) *
                        productRequestObj.productQuantity,
                      "Tk"
                    )}
                  </div>
                </div>
              )
            ) : (
              orderObj &&
              orderObj.items &&
              orderObj.items.map((item) =>
                item.skus.map((sku, index) => {
                  const img = sku.image || item.picture;
                  const variantLabel = [sku.color, sku.size]
                    .filter(Boolean)
                    .join(" / ");
                  return (
                    <div
                      key={`${item.id}-${index}`}
                      className="zp-inv-item-row"
                    >
                      {img && (
                        <img
                          src={img}
                          alt={item.name || "product"}
                          className="zp-inv-item-img"
                        />
                      )}
                      <div className="zp-inv-item-info">
                        <div className="zp-inv-item-name">
                          {(item.name || "").slice(0, 60)}
                        </div>
                        {variantLabel && (
                          <div className="zp-inv-item-variant">{variantLabel}</div>
                        )}
                        <div className="zp-inv-item-unit">
                          ৳{fmtAmt(sku.price)} × {fmtAmt(sku.totalQuantity)}
                        </div>
                      </div>
                      <div className="zp-inv-item-total">
                        {fmtAmt(parseFloat(sku.price) * sku.totalQuantity, "Tk")}
                      </div>
                    </div>
                  );
                })
              )
            )}

            {hasFreightInfo && (
            <div className="zp-inv-info-strip">
              <div className="zp-inv-info-item">
                <span className="k">Total Weight:</span>
                <span className="v">
                  {fmtAmt(renderableOrder && renderableOrder.receivedWeight, "Kg")}
                </span>
              </div>
              <div className="zp-inv-info-item">
                <span className="k">Customs &amp; Shipping Rate:</span>
                <span className="v">
                  {fmtAmt(renderableOrder && renderableOrder.customerRate, "Tk/Kg")}
                </span>
              </div>
              <div className="zp-inv-info-item">
                <span className="k">Total Shipping charge:</span>
                <span className="v">
                  {fmtAmt(
                    renderableOrder && renderableOrder.shippingChargeCustomer,
                    "Tk"
                  )}
                </span>
              </div>
              {renderableOrder && renderableOrder.refund ? (
                <div className="zp-inv-info-item">
                  <span className="k">Refunded amount:</span>
                  <span className="v">
                    {fmtAmt(renderableOrder.refund, "Tk")}
                  </span>
                </div>
              ) : null}
            </div>
            )}

            {renderableOrder &&
              renderableOrder.payments &&
              renderableOrder.payments.length > 0 && (
                <>
                  <div className="zp-inv-payments-title">
                    Previous Payments
                  </div>
                  <table className="zp-inv-payments-table">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Method</th>
                        <th>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {renderableOrder.payments.map((payment) => (
                        <tr>
                          <td>{payment.date}</td>
                          <td>{payment.method}</td>
                          <td>{payment.amount}Tk</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}
          </div>
          <div className="zp-inv-summary-wrap">
            <div className="zp-inv-summary">
              <div className="zp-inv-summary-row">
                <span className="k">Subtotal</span>
                <span className="v">৳{subtotal}</span>
              </div>
              <div className="zp-inv-summary-row">
                <span className="k">Delivery</span>
                <span className="v">
                  {deliveryCharge === 0 ? "Free" : `+৳${deliveryCharge}`}
                </span>
              </div>
              {discountApplied > 0 && (
                <div className="zp-inv-summary-row">
                  <span className="k">Discount</span>
                  <span className="v">-৳{discountApplied}</span>
                </div>
              )}
              {couponDiscount > 0 && (
                <div className="zp-inv-summary-row">
                  <span className="k">Coupon</span>
                  <span className="v">-৳{couponDiscount}</span>
                </div>
              )}
              {hasFreightInfo && (
                <>
                  {otherCost > 0 && (
                    <div className="zp-inv-summary-row">
                      <span className="k">Repackaging Charge</span>
                      <span className="v">+৳{otherCost}</span>
                    </div>
                  )}
                  {localShipping > 0 && (
                    <div className="zp-inv-summary-row">
                      <span className="k">Local Shipping (CN)</span>
                      <span className="v">+৳{localShipping}</span>
                    </div>
                  )}
                  {shippingChargeCustomer > 0 && (
                    <div className="zp-inv-summary-row">
                      <span className="k">Shipping Charge (CN to BD)</span>
                      <span className="v">+৳{shippingChargeCustomer}</span>
                    </div>
                  )}
                </>
              )}
              <div className="zp-inv-summary-row zp-inv-summary-row--subtotal">
                <span className="k">Total</span>
                <span className="v">
                  ৳{totalPayableAmountIncludingShipping}
                </span>
              </div>
              <div className="zp-inv-summary-row zp-inv-summary-row--paid">
                <span className="k">Paid</span>
                <span className="v">৳{totalPaid}</span>
              </div>
              {due > 0 && (
                <div className="zp-inv-summary-row zp-inv-summary-row--due">
                  <span className="k">Due</span>
                  <span className="v">৳{due}</span>
                </div>
              )}
            </div>
          </div>

          <div className="zp-inv-footer">
            {hasFreightInfo && (
              <div className="zp-inv-note">
                ******Freight, approx customs duty and 5% service charge
                included.
              </div>
            )}
            <div className="zp-inv-thanks">Thank You!</div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    orderObj: state.orders.orderObj,
    productRequestObj: state.productRequests.productRequestObj,
    users: [],
    admin: null,
    user: null,
    currency: state.users.currency,
  };
};
export default withRouter(
  connect(mapStateToProps, {
    getSingleOrderApiRedux,
    getSingleProductRequestRedux,
  })(OnlyInvoieToPrint)
);
